/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubLandingType from '@jira/spa-apps__servicedesk-knowledge-hub-landing/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubLanding: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubLandingType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-landing", jiraSpaEntry: "async-servicedesk-knowledge-hub-landing" */ '@jira/spa-apps__servicedesk-knowledge-hub-landing/src/index.tsx'
			),
	);

const AsyncServicedeskKnowledgeHubLanding = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubLanding}
		pageId="spa-apps/servicedesk/knowledge-hub/landing-page"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubLanding;
